// extracted by mini-css-extract-plugin
export default {"star":"BGLUIQqeke3PVEa","action-positive":"aba7zGE3XKRYFPN","action-negative":"hmONnYza8JCaGDf","click-positive":"trhFrWivddlx014"};